<template>
  <div>
    <div class="section operations">
      <div v-show="cooperateEdit" class="triggers">
        <cargo-button-group-slider>
          <div>
            <el-button no="1" type="primary" @click="importFileBtnClickHandler()">{{ $t('SeaExport.ExcelImport') }}</el-button>
            <el-button no="2" type="primary" @click="updateStatusHandler()">{{ $t('SeaExport.UpdateStatus') }}</el-button>
            <el-button no="3" type="primary" @click="deleteBtnClickHandler()">{{ $t('SeaExport.ClearThePackingInformation') }}</el-button>
            <el-button no="4" type="primary" @click="exportBtnClickHandler()">{{ $t('SeaExport.ExportThePackingPlan') }}</el-button>
            <el-button no="5" type="primary" @click="exportPackSlipBtnClickHandler()">PACK SLIP</el-button>
            <el-button no="6" type="primary" @click="exportShipmentReportBtnClickHandler()">Shipment Report</el-button>
            <el-button no="7" type="primary" @click="exportWeeklyLoadingPlanBtnClickHandler()">Weekly Loading Plan</el-button>
            <el-button no="8" type="primary" @click="exportWarehousingFeeBtnClickHandler()">{{ $t('SeaExport.WarehousingFee') }}</el-button>
            <el-button no="9" type="primary" @click="exportLoadingListBtnClickHandler()">loading List</el-button>
            <el-button no="10" type="primary" @click="exportPackSlipForFCLListExcelFile()">Pack Slip For FCL</el-button>
            <el-button no="print" type="success" @click="toPrint">{{ $t('CargoMsg.Cargo_Print') }}</el-button>
          </div>
        </cargo-button-group-slider>
      </div>
    </div>
    <cargo-left-right-resize
      :left-style="{display: 'flex', flexDirection: 'column', 'min-width':'250px', 'max-width':'250px'}"
      :right-style="{display: 'flex', flexDirection: 'column',width:'80%'}"
      style="height: 100%;min-height: 300px"
    >
      <template
        slot="left"
      >
        <div class="section" style="height: 100%; overflow: hidden;">
          <div style="float:left; margin-bottom: 13px;">
            <span class="title">{{ $t('SeaExport.ContainerList') }}</span>
          </div>
          <el-scrollbar style="height:100%;">
            <el-card v-for="(item,index) in elCardList" :key="index" :style="item.uuid === containerUuid ? 'background-color: #E7F5FF;' : ''" @click.native="containerClickHandler(item)">
              <div style="cursor:pointer">
                <div>
                  <div style="float:left; font-weight: bold;">
                    {{ item.eqSizeAndType }}
                  </div>
                  <div style="float:right; color: red;">
                    {{ CommonState.getNameByCode(SeaExportConstants.CONTAINER_STATE, item.state) }}
                  </div>
                </div>
                <br>
                <br>
                <div>
                  {{ $t('SeaExport.ContainerNo') }}：{{ item.containerNo }}
                </div>
                <br>
                <div>
                  {{ $t('SeaExport.SealNo') }}：{{ item.sealNo }}
                </div>
                <br>
                <div>
                  {{ $t('SeaExport.ActualPackingTime') }}：{{ item.loadingDate }}
                </div>
              </div>
            </el-card>
          </el-scrollbar>
        </div>
      </template>
      <template slot="right">
        <div style="padding:5px 0;">
          <div style="float:left;">
            <span class="title">{{ $t('SeaExport.ContainerInfo') }}</span>
          </div>
          <div style="float:right">
            <el-form :inline="true" label-width="90px" label-position="right">
              <el-form-item :label="totalLabel.OrderNumber">
                {{ totalDesc.orderNum }}
              </el-form-item>
              <el-form-item :label="totalLabel.TotalPacking">
                {{ totalDesc.estimatedTotalPackings }} / {{ totalDesc.totalPackings }}
              </el-form-item>
              <el-form-item :label="totalLabel.TotalCubage">
                {{ totalDesc.estimatedTotalCubages }} / {{ totalDesc.totalCubages }}
              </el-form-item>
              <el-form-item :label="totalLabel.TotalWeight2">
                {{ totalDesc.estimatedTotalWeight }} / {{ totalDesc.totalWeight }}
              </el-form-item>
            </el-form>
          </div>
        </div>
        <div class="section" style="flex: 1;">
          <cargo-ag-grid
            config-module="130130"
            :grid-options="gridOptions"
            :grid-params.sync="gridParams"
            :column-defs="columnDefs"
            :row-data="rowData"
            style="flex-grow:1"
            @gridReady="params=>gridApi=params.api"
          />
        </div>
      </template>
    </cargo-left-right-resize>

    <!-- 查看商品弹窗 -->
    <check-the-goods-window
      :visible.sync="goodsDialog.visible"
      :result-list="goodsDialog.resultList || []"
    />
    <!-- 查看包装弹窗 -->
    <check-the-packages-window
      :visible.sync="packagesDialog.visible"
      :result-list="packagesDialog.resultList || []"
    />

    <!-- Excel上传弹窗 -->
    <import-cabinet-list-window
      :visible.sync="importCabinetListWindow.visible"
      :job-uuid="importCabinetListWindow.jobUuid"
      @uploadExcelSuccess="loadPoInfoList"
    />

    <!-- 状态修改弹窗 -->
    <update-container-po-window
      :visible.sync="stateDialog.visible"
      :state="stateDialog.state"
      :container-uuid="stateDialog.containerUuid"
      :actual-packing-time="stateDialog.actualPackingTime"
      @fun="creationCompleteHandler"
      @changeStateFun="changeStateFun"
    />

    <!-- 打印报表对话框 -->
    <cargo-template-selector-dialog
      :visible.sync="templateSelectorDialog.visible"
      :ctx="templateSelectorDialog.cxt"
      :category="templateSelectorDialog.category"
      :data="templateSelectorDialog.data"
    />
  </div>
</template>

<script>
import URL from '@/api/urlTranslator'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'

import { AbstractEntity as Job } from '@/class/model/AbstractEntity'
import TradeDetailContainerLinkedDialog from '@/components/Cargo/Job/tradeDetailContainerLinkedDialog'
import cargoTemplateSelectorDialog from '@/components/Cargo/Common/cargoTemplateSelectorDialog'
import ColumnUtils from '@/utils/ColumnUtils'
import CargoButtonGroupSlider from '@/components/Cargo/Common/CargoButtonGroupSlider'
import CargoAgGridSelectEditor from '@/components/Cargo/Common/CargoAgGridSelectEditor/index'
import CargoAgGridAdvanceSelectEditor from '@/components/Cargo/Common/CargoAgGridAdvanceSelectEditor'
import cargoLeftRightResize from '@/components/Cargo/Common/cargoLeftRightResize'
import OperationRender from '@/components/OperationRender/index'
import { queryContainersByJobUuid, queryPoInfoList, removePoInfo, queryPackageList, queryGoodsList, clearContainerPo,
  exportLoadingListExcelFile, exportCabinetListExcelFile, exportPackSlipExcel, exportPoExcel, exportWarehouseFee,
  exportPackSlipForFCLListExcelFile } from '@/api/seaExport/container'
import { getLoading } from '@/utils/utilBaseElement'
import CheckTheGoodsWindow from '@/views/cargo/v0/Clearing/components/booking/CheckTheGoodsWindow'
import CheckThePackagesWindow from '@/views/cargo/v0/Clearing/components/booking/CheckThePackagesWindow'
import ImportCabinetListWindow from '@/views/cargo/v0/Clearing/components/booking/ImportCabinetListWindow'
import * as SeaExportConstants from '@/class/cargo/model/parameters/SeaExportConstants'
import UpdateContainerPoWindow from '@/views/cargo/v0/Clearing/components/booking/UpdateContainerPoWindow'
import * as CommonState from '@/class/cargo/model/parameters/CommonState'
import { SeaExportJob } from '@/class/model/booking/SeaExportJob'
import { cache } from '@/utils/cacheManager'

export default {
  name: 'TabPoItemsUpgrade',
  components: { UpdateContainerPoWindow, ImportCabinetListWindow, CheckThePackagesWindow, CheckTheGoodsWindow, OperationRender, cargoLeftRightResize, CargoButtonGroupSlider, TradeDetailContainerLinkedDialog, cargoTemplateSelectorDialog, CargoAgGridAdvanceSelectEditor },
  props: {
    context: {
      type: Object,
      required: true
    },
    action: {
      type: String,
      required: true
    },
    cooperateEdit: { // 能否修改
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      URL,
      CommonState,
      SeaExportConstants,
      selectTypeNames: TYPE_NAMES,
      gridParams: {},
      gridOptions: {
        rowSelection: 'multiple',
        suppressCellSelection: true,
        singleClickEdit: true,
        context: {
          componentParent: this
        },
        frameworkComponents: { // 添加编辑组件
          CargoAgGridAdvanceSelectEditor,
          CargoAgGridSelectEditor
        },
        onRowDragEnd: this.refreshSequenceNo
      },
      rowData: [],
      gridApi: null,
      job: new Job().fillDefaultValue().getData(),
      poInfoList: [],
      totalDesc: { // 合计汇总
        orderNum: 0,
        estimatedTotalPackings: 0,
        totalPackings: 0,
        estimatedTotalCubages: 0,
        totalCubages: 0,
        estimatedTotalWeight: 0,
        totalWeight: 0
      },
      totalLabel: { // 合计汇总label
        OrderNumber: this.$t('SeaExport.OrderNumber') + ':',
        TotalPacking: this.$t('SeaExport.TotalPacking') + ':',
        TotalCubage: this.$t('SeaExport.TotalCubage') + ' CBM:',
        TotalWeight2: this.$t('SeaExport.TotalWeight2') + 'KGS:'
      },
      elCardList: [], // 集装箱列表集合
      containerUuid: '',
      containerState: 0,
      actualLoadingTime: '',
      loading: false,
      packagesDialog: { // 查看包装
        visible: false,
        resultList: []
      },
      goodsDialog: { // 查看商品
        visible: false,
        resultList: []
      },
      stateDialog: { // 更新状态
        visible: false,
        state: 0,
        containerUuid: '',
        actualPackingTime: ''
      },
      importCabinetListWindow: { // excel 导入
        visible: false,
        jobUuid: ''
      },
      // 模板选择弹窗
      templateSelectorDialog: {
        visible: false,
        cxt: new SeaExportJob(),
        category: 'SEPOITEMS',
        data: {
          POITEMS_UUID: []
        }
      }
    }
  },
  computed: {
    readonly() {
      if (!this.cooperateEdit) return true
      return this.action === 'look'
    },
    isEdit() {
      if (!this.cooperateEdit) return false
      return this.action !== 'look'
    },
    user() {
      return this.context.user || {}
    },
    language() {
      return this.$store.getters.language
    },
    columnDefs() {
      const columnDefs =
         [
           {
             headerName: this.$t('SeaExport.OrderNo'),
             field: 'poNo',
             colId: 'poNo',
             width: 150
           },
           {
             headerName: this.$t('SeaExport.NumberOfPackages'),
             field: 'numberOfPackages',
             colId: 'numberOfPackages',
             width: 150,
             cellRenderer: (item) => {
               const { data } = item
               return `<span style="color:blue">${data.estimatedNumberOfPackages}</span> /
                       <span style="color:${data.packageColor}">${data.numberOfPackages}</span>`
             }
           },
           {
             headerName: this.$t('SeaExport.Weight') + ' KGS',
             field: 'weight',
             colId: 'weight',
             width: 150,
             cellRenderer: (item) => {
               const { data } = item
               const estimatedWeight = ColumnUtils.number3ColumnLabelFunc(data.estimatedWeight)
               const weight = ColumnUtils.number3ColumnLabelFunc(data.weight)
               return `<span style="color:blue">${estimatedWeight}</span> /
                       <span style="color:${data.weightColor}">${weight}</span>`
             }
           },
           {
             headerName: this.$t('SeaExport.Cubage') + ' CBM',
             field: 'cubage',
             colId: 'cubage',
             width: 150,
             cellRenderer: (item) => {
               const { data } = item
               const estimatedCubage = ColumnUtils.number3ColumnLabelFunc(data.estimatedCubage)
               const cubage = ColumnUtils.number3ColumnLabelFunc(data.cubage)
               return `<span style="color:blue">${estimatedCubage}</span> /
                       <span style="color:${data.cubageColor}">${cubage}</span>`
             }
           },
           {
             headerName: this.$t('SeaExport.AskForPositionTime'),
             field: 'requestedIncomeDate',
             colId: 'requestedIncomeDate',
             width: 150
           },
           {
             headerName: this.$t('SeaExport.EstimatedPositionTime'),
             field: 'estimatedIncomeDate',
             colId: 'estimatedIncomeDate',
             width: 150
           },
           {
             headerName: this.$t('SeaExport.Customer'),
             field: 'custmorId',
             colId: 'custmorId',
             width: 150,
             valueFormatter(params) {
               return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', params.value, 'chineseName')
             }
           },
           {
             headerName: this.$t('SeaExport.Supplier'),
             field: 'supplierId',
             colId: 'supplierId',
             width: 150,
             valueFormatter(params) {
               return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', params.value, 'chineseName')
             }
           },
           {
             headerName: this.$t('SeaExport.OperationRequirements'),
             field: 'operationRequirement',
             colId: 'operationRequirement',
             width: 150
           },
           {
             headerName: this.$t('SeaExport.Remarks'),
             field: 'remarks',
             colId: 'remarks',
             width: 150
           },
           {
             headerName: this.$t('SeaExport.CheckTheDetailsOfTheGoods'),
             field: 'itemNo',
             colId: 'itemNo',
             width: 150,
             cellStyle: { textAlign: 'center' },
             cellRendererFramework: OperationRender,
             cellRendererParams: {
               operations: [
                 {
                   title: this.$t('SeaExport.checkGoods'),
                   type: 'primary',
                   cssStyle: 'text-decoration: underline; color: #1605FB',
                   onClick: (params) => {
                     this.checkTheGoodsClickHandler(params)
                   },
                   visible: (params) => params && params.poInfoUuid
                 },
                 {
                   title: this.$t('SeaExport.checkPackages'),
                   type: 'primary',
                   cssStyle: 'text-decoration: underline; color: #1605FB',
                   onClick: (params) => {
                     this.checkThePackingClickHandler(params)
                   },
                   visible: (params) => params && params.poInfoUuid
                 }
               ]
             }
           },
           {
             headerName: this.$t('SeaExport.Operation'),
             field: 'subItemNo',
             colId: 'subItemNo',
             width: 150,
             cellStyle: { textAlign: 'center' },
             cellRendererFramework: OperationRender,
             cellRendererParams: {
               operations: [
                 {
                   title: this.$t('SeaExport.Remove'),
                   type: 'primary',
                   cssStyle: 'text-decoration: underline; color: #1605FB',
                   onClick: (params) => {
                     this.removePoClickHandler(params)
                   },
                   visible: (params) => params && params.poInfoUuid
                 }
               ]
             }
           }
         ]
      return columnDefs
    }
  },
  methods: {
    async onShow(row, isRefresh) {
      if (!row) {
        return
      }
      this.job = row
      this.elCardList = []
      this.rowData = []
      if (!this.job.uuid) return
      this.creationCompleteHandler()
    },
    creationCompleteHandler() {
      // Container.queryContainersByJobUuid(job.key, containerListResultHandler, faultHandler)
      // 重新加载 装箱信息列表
      this.loading = getLoading()
      queryContainersByJobUuid({ anyStr: this.job.uuid }).then(res => {
        const result = res.data
        const list = []
        for (const container of result) {
          const item = {}
          item.uuid = container.UUID
          item.state = container.STATE ? parseInt(container.STATE) : 0
          item.eqSizeAndType = container.EQSIZEANDTYPE
          item.containerNo = container.CONTAINERNO
          item.sealNo = container.SEALNO
          item.loadingDate = container.LOADING_DATE
          list.push(item)
        }
        this.elCardList = list
      }).finally(() => {
        this.loading.close()
      })
    },
    // 选中箱子，带出右边列表数据
    containerClickHandler(item) {
      for (const element of this.elCardList) {
        if (element.uuid === item.uuid) {
          this.containerState = item.state
          this.actualLoadingTime = item.loadingDate
          this.containerUuid = item.uuid
          this.loadPoInfoList()
        }
      }
    },
    // 加载右边列表的数据
    loadPoInfoList() {
      if (!this.containerUuid) {
        this.rowData = []
        return
      }
      // PoInfo.queryPoInfoList(containerUuid, loadPoInfoItem, faultHandler);
      this.loading = getLoading()
      queryPoInfoList({ anyStr: this.containerUuid }).then(res => {
        const result = res.data
        this.rowData = result.poList || []
        const poMap = result.totalPoMap
        if (poMap) {
          this.totalDesc.orderNum = poMap.orderNum || 0
          this.totalDesc.estimatedTotalPackings = poMap.estimatedTotalPackings || 0
          this.totalDesc.totalPackings = poMap.totalPackings || 0
          this.totalDesc.estimatedTotalCubages = ColumnUtils.number3ColumnLabelFunc(poMap.estimatedTotalCubages)
          this.totalDesc.totalCubages = ColumnUtils.number3ColumnLabelFunc(poMap.totalCubages)
          this.totalDesc.estimatedTotalWeight = ColumnUtils.number3ColumnLabelFunc(poMap.estimatedTotalWeight)
          this.totalDesc.totalWeight = ColumnUtils.number3ColumnLabelFunc(poMap.totalWeight)
        }
      }).finally(() => {
        this.loading.close()
      })
    },
    // Excel导入
    importFileBtnClickHandler() {
      this.importCabinetListWindow.jobUuid = this.job.uuid
      this.importCabinetListWindow.visible = true
    },
    // 更新状态
    updateStatusHandler() {
      this.stateDialog.state = this.containerState || 0
      this.stateDialog.containerUuid = this.containerUuid
      this.stateDialog.actualPackingTime = this.actualPackingTime
      this.stateDialog.visible = true
    },
    // 清除装箱信息
    deleteBtnClickHandler() {
      if ((this.containerState !== 0 && !this.containerState) || !this.containerUuid) {
        this.$message.warning(this.$t('SeaExport.firstCleanedContainer'))
        return
      }
      if (this.containerState !== 0) {
        const state = CommonState.getNameByCode(SeaExportConstants.CONTAINER_STATE, this.containerState)
        this.$message.warning(state + this.$t('SeaExport.containerBeCleared'))
        return
      }
      this.$confirm(this.$t('SeaExport.removeSelectedContainer'), this.$t('SeaExport.ClearContainerInformation'), {
        confirmButtonText: this.$t('common.btn.ok'),
        cancelButtonText: this.$t('common.btn.cancel'),
        closeOnClickModal: false,
        type: 'warning'
      }).then(() => {
        // ContainerPo.clearContainerPo(_containerUuid, clearContainerPoResultHandler, faultHandler);
        this.loading = getLoading()
        clearContainerPo({ anyStr: this.containerUuid }).then(res => {
          this.loadPoInfoList()
        }).finally(() => {
          this.loading.close()
        })
      })
    },
    // 导出装箱计划
    exportBtnClickHandler() {
      // Container.exportCabinetListExcelFile(job.key, onExportSucceededHandler, faultHandler);
      // const url = `${URL.seaExport.exportCabinetListExcelFile}` + '?jobUuid=' + encodeURIComponent(this.job.uuid) + '&jobNo=' + encodeURIComponent(this.job.jobNo) + '&branchId=' + this.$store.getters.currentOfficeId + '&sessionId=' + encodeURIComponent(this.$store.getters.token)
      // window.open(url)

      this.loading = getLoading()
      const item = {}
      item.anyStr = this.job.uuid
      item.anyStr1 = this.job.jobNo
      item.branchId = this.$store.getters.currentOfficeId
      exportCabinetListExcelFile(item).then(res => {
        const result = res.data
        this.exportResultHandler(result)
      }).finally(() => {
        this.loading.close()
      })
    },
    // PACK SLIP
    exportPackSlipBtnClickHandler() {
      // EDIContainer.exportPackSlipExcel(job.key, job.jobNo, exportResultHandler, faultHandler);
      // const url = `${URL.seaExport.exportPackSlipExcel}` + '?jobUuid=' + encodeURIComponent(this.job.uuid) + '&jobNo=' + encodeURIComponent(this.job.jobNo) + '&branchId=' + this.$store.getters.currentOfficeId + '&sessionId=' + encodeURIComponent(this.$store.getters.token)
      // window.open(url)

      this.loading = getLoading()
      const item = {}
      item.anyStr = this.job.uuid
      item.anyStr1 = this.job.jobNo
      item.branchId = this.$store.getters.currentOfficeId
      exportPackSlipExcel(item).then(res => {
        const result = res.data
        this.exportResultHandler(result)
      }).finally(() => {
        this.loading.close()
      })
    },
    // Shipment Report
    exportShipmentReportBtnClickHandler() {
      // PoInfo.exportPoExcel(_fileName, jobUuids, exportResultHandler, faultHandler);
      // const url = `${URL.seaExport.exportPoExcel}` + '?anyStr=' + encodeURIComponent(this.job.uuid) + '&branchId=' + this.$store.getters.currentOfficeId + '&sessionId=' + encodeURIComponent(this.$store.getters.token) + '&fileName=Shipment Report'
      // window.open(url)

      this.loading = getLoading()
      const item = {}
      item.keys = [this.job.uuid]
      item.anyStr = 'Shipment Report'
      item.branchId = this.$store.getters.currentOfficeId
      exportPoExcel(item).then(res => {
        const result = res.data
        this.exportResultHandler(result)
      }).finally(() => {
        this.loading.close()
      })
    },
    // Weekly Loading Plan
    exportWeeklyLoadingPlanBtnClickHandler() {
      // PoInfo.exportPoExcel(_fileName, jobUuids, exportResultHandler, faultHandler);
      // const url = `${URL.seaExport.exportPoExcel}` + '?anyStr=' + encodeURIComponent(this.job.uuid) + '&branchId=' + this.$store.getters.currentOfficeId + '&sessionId=' + encodeURIComponent(this.$store.getters.token) + '&fileName=Weekly Loading Plan'
      // window.open(url)

      this.loading = getLoading()
      const item = {}
      item.keys = [this.job.uuid]
      item.anyStr = 'Weekly Loading Plan'
      item.branchId = this.$store.getters.currentOfficeId
      exportPoExcel(item).then(res => {
        const result = res.data
        this.exportResultHandler(result)
      }).finally(() => {
        this.loading.close()
      })
    },
    // 仓储费
    exportWarehousingFeeBtnClickHandler() {
      // PoInfo.exportWarehouseFee(job.key, exportResultHandler, faultHandler);
      // const url = `${URL.seaExport.exportWarehouseFee}` + '?jobUuid=' + encodeURIComponent(this.job.uuid) + '&branchId=' + this.$store.getters.currentOfficeId + '&sessionId=' + encodeURIComponent(this.$store.getters.token) + '&fileName=WarehouseFee'
      // window.open(url)

      this.loading = getLoading()
      const item = {}
      item.anyStr = this.job.uuid
      item.anyStr1 = 'WarehouseFee'
      item.branchId = this.$store.getters.currentOfficeId
      exportWarehouseFee(item).then(res => {
        const result = res.data
        this.exportResultHandler(result)
      }).finally(() => {
        this.loading.close()
      })
    },
    // loading List
    exportLoadingListBtnClickHandler() {
      // Container.exportLoadingListExcelFile(job.key, exportResultHandler, faultHandler);
      // const url = `${URL.seaExport.exportLoadingListExcelFile}` + '?jobUuid=' + encodeURIComponent(this.job.uuid) + '&branchId=' + this.$store.getters.currentOfficeId + '&sessionId=' + encodeURIComponent(this.$store.getters.token)
      // window.open(url)
      this.loading = getLoading()
      const item = {}
      item.anyStr = this.job.uuid
      item.branchId = this.$store.getters.currentOfficeId
      exportLoadingListExcelFile(item).then(res => {
        const result = res.data
        this.exportResultHandler(result)
      }).finally(() => {
        this.loading.close()
      })
    },
    // 下载处理，公用
    exportResultHandler(result) {
      if (!result || !result.success) {
        this.$message.error(result.errMsg)
        return
      }
      // 从云存储上下载文件
      if (!result.documentId) {
        this.$message.warning(this.$t('SeaExport.NoCorrespondingFile'))
        return
      }
      const storageURL = cache.config.get('StorageURL')
      const url = `${URL.common.findByFileId}/${result.documentId}?sessionId=${this.$store.getters.token}`
      window.open(url)
    },
    // Pack Slip For FCL
    exportPackSlipForFCLListExcelFile() {
      // Container.exportPackSlipForFCLListExcelFile(job.key, job.jobNo, exportResultHandler, faultHandler);
      // const url = `${URL.seaExport.exportPackSlipForFCLListExcelFile}` + '?jobUuid=' + encodeURIComponent(this.job.uuid) + '&jobNo=' + encodeURIComponent(this.job.jobNo) + '&branchId=' + this.$store.getters.currentOfficeId + '&sessionId=' + encodeURIComponent(this.$store.getters.token)
      // window.open(url)

      this.loading = getLoading()
      const item = {}
      item.anyStr = this.job.uuid
      item.anyStr1 = this.job.jobNo
      item.branchId = this.$store.getters.currentOfficeId
      exportPackSlipForFCLListExcelFile(item).then(res => {
        const result = res.data
        this.exportResultHandler(result)
      }).finally(() => {
        this.loading.close()
      })
    },
    // 查看商品
    checkTheGoodsClickHandler(item) {
      const poInfoUuid = item.poInfoUuid
      // PoInfo.queryGoodsList(poInfoUuid, goodsPageResultHandler, faultHandler);
      this.loading = getLoading()
      queryGoodsList({ anyStr: poInfoUuid }).then(res => {
        this.goodsDialog.resultList = res.data || []
        this.goodsDialog.visible = true
      }).finally(() => {
        this.loading.close()
      })
    },
    // 查看包装
    checkThePackingClickHandler(item) {
      const poInfoUuid = item.poInfoUuid
      // PoInfo.queryPackageList(poInfoUuid, packagePageResultHandler, faultHandler);
      this.loading = getLoading()
      queryPackageList({ anyStr: poInfoUuid }).then(res => {
        this.packagesDialog.resultList = res.data || []
        this.packagesDialog.visible = true
      }).finally(() => {
        this.loading.close()
      })
    },
    // 移除Po
    removePoClickHandler(item) {
      const poInfoUuid = item.poInfoUuid
      if (this.containerState !== 0) {
        this.$message.warning(this.$t('SeaExport.UnableToRemove'))
        return
      }
      this.$confirm(this.$t('SeaExport.removeOrderTips'), this.$t('SeaExport.removeOrder'), {
        confirmButtonText: this.$t('common.btn.ok'),
        cancelButtonText: this.$t('common.btn.cancel'),
        closeOnClickModal: false,
        type: 'warning'
      }).then(() => {
        if (!poInfoUuid) return
        // ContainerPo.removePoInfo(poInfoUuid, removeResultHandler, faultHandler);
        this.loading = getLoading()
        removePoInfo({ anyStr: poInfoUuid }).then(res => {
          const result = res.data
          if (result && parseInt(result) === 1) {
            this.loadPoInfoList()
          }
        }).finally(() => {
          this.loading.close()
        })
      })
    },
    // 更改状态回调
    changeStateFun(containerState) {
      this.containerState = containerState.state
      const iList = this.job.containers
      if (this.readonly && (!iList || iList.length <= 0)) {
        new SeaExportJob(this.job).getContainers()
      }
      if (iList && iList.length > 0) {
        for (const container in iList) {
          if (container.uuid === this.containerUuid) {
            container.state = containerState.state
            container.loadingDate = containerState.loadingDate
          }
        }
      }
      this.containerState = 0
      this.containerUuid = ''
      this.rowData = []
    },
    toPrint() {
      this.templateSelectorDialog.cxt = new SeaExportJob(this.job)
      this.templateSelectorDialog.data = { 'POITEMS_UUID': [], 'JOB_UUID': this.job.uuid }
      this.templateSelectorDialog.category = 'SEPOITEMS'
      this.templateSelectorDialog.visible = true
    }
  }
}
</script>

<style>
</style>
